import { Inject, Injectable, ViewContainerRef } from "@angular/core";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { DwdmDiagramAbstractConverterEnd } from "../../diagram/converter/dwdm-diagram-abstract-converter-end";
import { DwdmDiagramConverterMuxService } from "../../diagram/converter/dwdm-diagram-converter-mux.service";
import { EndConverterData, EndpointElementIdentifier } from "../../diagram/converter/dwdm-diagram-converter.models";
import { DwdmDiagramDiagnosticConverterAmplifiersService } from "./dwdm-diagram-diagnostic-converter-amplifiers.service";
import { DwdmDiagramDiagnosticConverterOscsService } from "./dwdm-diagram-diagnostic-converter-oscs.service";
import { DwdmDiagramDiagnosticConverterTranspondersService } from "./dwdm-diagram-diagnostic-converter-transponders.service";

/**
 * Responsável por converter {@link EndConverterData} em {@link EndpointElementIdentifier}.
 * Pode ser usado tanto para o A-END quanto para o Z-END.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramDiagnosticConverterEndService extends DwdmDiagramAbstractConverterEnd {

    constructor(@Inject(ANGULARJS_TRANSLATE) translate: any,
            private readonly muxConverterService: DwdmDiagramConverterMuxService,
            private readonly transpondersConverterService: DwdmDiagramDiagnosticConverterTranspondersService,
            private readonly amplifiersConverterService: DwdmDiagramDiagnosticConverterAmplifiersService,
            private readonly oscsConverterService: DwdmDiagramDiagnosticConverterOscsService) {
        super(translate);
    }

    public convert(endConverterData: EndConverterData,
        diagnosticData: any, diagnosticModalViewRef: ViewContainerRef): EndpointElementIdentifier {

        return this.convertData(endConverterData, {
            transponders: (data) => this.transpondersConverterService.convert(data, diagnosticData, diagnosticModalViewRef),
            mux: (data) => this.muxConverterService.convert(data),
            amplifiers: (data) => this.amplifiersConverterService.convert(data, diagnosticData, diagnosticModalViewRef),
            oscs: (data) => this.oscsConverterService.convertForEnd(data, diagnosticData, diagnosticModalViewRef)
        });
    }
}
